var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _g2, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOwnTechnologies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2586 1795",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M626 1545.89L1448.94 1452L1818.5 1627L977.811 1736L626 1545.89Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2060.22 289.391L1357.17 377.489L1358.55 1290.93L2067.08 1408.54L2376.71 1341.73L2378.09 329.599L2060.22 289.391Z",
    fill: "#DBDBDB",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2242.5 493.5L2180.95 496.896C2169.65 496.399 2113.63 545.445 2112 637.5C2112 767.945 2170.86 796.003 2182.16 796.501L2242.5 796.5L2242.5 493.5Z",
    fill: "#181717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2238.5 993.5L2176.95 996.896C2165.65 996.399 2109.63 1045.44 2108 1137.5C2108 1267.94 2166.86 1296 2178.16 1296.5L2238.5 1296.5L2238.5 993.5Z",
    fill: "#181717"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.75 1297.47L2119.45 1262.04",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1993.22 565.82L1564.08 577.99V977.127L2002.98 1026.88V574.975L1993.22 565.82Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2244.03 796.457C2303.08 796.457 2350.96 728.66 2350.96 645.028C2350.96 561.395 2303.08 493.598 2244.03 493.598C2184.98 493.598 2137.11 561.395 2137.11 645.028C2137.11 728.66 2184.98 796.457 2244.03 796.457Z",
    fill: "#96290D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2244.03 713.24C2270.94 713.24 2292.75 682.7 2292.75 645.026C2292.75 607.353 2270.94 576.812 2244.03 576.812C2217.12 576.812 2195.31 607.353 2195.31 645.026C2195.31 682.7 2217.12 713.24 2244.03 713.24Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2244.03 1296.46C2303.08 1296.46 2350.96 1228.66 2350.96 1145.03C2350.96 1061.4 2303.08 993.598 2244.03 993.598C2184.98 993.598 2137.11 1061.4 2137.11 1145.03C2137.11 1228.66 2184.98 1296.46 2244.03 1296.46Z",
    fill: "#96290D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2244.03 1213.24C2270.94 1213.24 2292.75 1182.7 2292.75 1145.03C2292.75 1107.35 2270.94 1076.81 2244.03 1076.81C2217.12 1076.81 2195.31 1107.35 2195.31 1145.03C2195.31 1182.7 2217.12 1213.24 2244.03 1213.24Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1819.55 905.291V927.298H1896.2L1906.78 913.548H1939.81V625.989L1890.92 603.982H1830.13L1819.55 637.01V905.291Z",
    fill: "#373737",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1873.71 636.975H1819.55V905.255H1873.71V636.975Z",
    fill: "#96290D",
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2033.63 770.451L1908.09 760.83V883.249L2028.32 901.163L2033.63 770.451Z",
    fill: "#373737",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1909.5 775.729L2032.11 786.606",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.85 817.156L2030.18 832.091",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.19 837.512L2030.18 853.81",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1906.88 855.174L2028.22 872.837",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.09 760.829V686.768L1916.02 691.506V760.793L1908.09 760.829Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.51 938.535V1240.13L1445.54 1242.32V941.838L1425.51 938.535Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.54 941.838L1681.97 929.129V964.275L2035.56 1004.95V1134.62L1972.26 1153.32L1678.8 1113.76V1190.66L2022.91 1243.43V1343.41L1445.54 1242.32V941.838Z",
    fill: "#ABABAB",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1681.97 964.275L1444.47 981.4L1909.95 1017.05L2035.56 1004.95L1681.97 964.275Z",
    fill: "#ABABAB",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1909.95 1017.05V1143.42L1970 1152.5L2017 1143.42V1007L1909.95 1017.05Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.47 981.398V1091.22L1678.8 1113.76L1909.95 1143.42V1017.05L1444.47 981.398Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1542.95 1096.78L1569.32 1045.34L1758.76 1065.05L1771.93 1079.62",
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.51 938.535L1588.77 926.473L1681.97 929.129L1445.54 941.838L1425.51 938.535Z",
    fill: "#373737",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1446.99 1159.68L1678.8 1133.5V1173L1446.3 1221L1445.54 1242.32L1678.8 1190.66V1113.76L1611.39 1107.62L1445.61 1119.04L1446.99 1159.68Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1559 1220V1264.48C1559 1275.8 1613.6 1285 1680.93 1285C1748.27 1285 1803 1275.8 1803 1264.48V1220H1559Z",
    fill: "#373737"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1681 1240C1748.38 1240 1803 1230.82 1803 1219.5C1803 1208.18 1748.38 1199 1681 1199C1613.62 1199 1559 1208.18 1559 1219.5C1559 1230.82 1613.62 1240 1681 1240Z",
    fill: "#96290D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1703 1215.5C1703 1219.13 1688.67 1222 1671.01 1222C1653.35 1222 1639 1219.1 1639 1215.5C1639 1211.91 1653.33 1209 1671.01 1209C1688.7 1209 1703 1211.91 1703 1215.5Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1819.99 1246L1819 1290.6C1818.75 1301.99 1873.18 1326.98 1940.56 1329.5C2007.94 1332.01 2062.79 1324.86 2063.04 1313.48L2064 1255.16L1819.99 1246Z",
    fill: "#373737"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2064 1255.53C2063.75 1266.88 2008.91 1274 1941.56 1271.5C1874.21 1268.99 1819.75 1257.75 1820 1246.44C1820.25 1235.13 1875.09 1227.97 1942.47 1230.51C2009.84 1233.05 2064.25 1244.22 2064 1255.53Z",
    fill: "#96290D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1964 1247.65C1964 1251.24 1949.56 1253.54 1931.92 1252.89C1914.28 1252.25 1900 1248.91 1900 1245.32C1900 1241.73 1914.44 1239.44 1932.08 1240.12C1949.72 1240.8 1964.08 1244.1 1964 1247.65Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1443 371.127V420.849L1660.86 444L2341 393.089V316.76L2182.93 289L1443 371.127Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.2 420.857L1998.19 358.57L2192.03 393.178L1624.87 443.941L1443.2 420.857Z",
    fill: "#373737"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1736.86 770V709.025C1723.32 709.025 1712.35 720.453 1712.35 734.55V811.448C1712.35 825.545 1723.32 836.973 1736.86 836.973H1783.41C1796.95 836.973 1807.93 825.545 1807.93 811.448V777C1770.5 777 1768.45 789 1736.86 770Z",
    fill: "#373737",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1774.52 730.457H1745.76C1736.16 730.457 1728.38 738.558 1728.38 748.551V797.375C1728.38 807.367 1736.16 815.468 1745.76 815.468H1774.52C1784.11 815.468 1791.89 807.367 1791.89 797.375V748.551C1791.89 738.558 1784.11 730.457 1774.52 730.457Z",
    fill: "#A7A7A7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2055.5 252.5L2065.66 1428.82L2386.33 1356.23V312.33L2055.5 252.5ZM2366.95 1327.22L2103.35 1381.07L2106.04 312.33L2366.88 357.349L2366.95 1327.22Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2060.5 250.5L1340 340V1304.13L2071 1429L2060.5 250.5ZM1376.49 1278.17L1370.87 389.119L2017.69 316.324L2021.92 1389.82L1376.49 1278.17Z",
    fill: "#707070",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1630.01 459.629V555.805",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_450_3993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1366 390L2015 316L2033.5 1391L1366 1285V390Z",
    fill: "#7D7D7D",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_450_3993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2105.5 309L2367 358V1326L2105.5 1376.5V309Z",
    fill: "#7D7D7D",
    fillOpacity: 0.2
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M257.6 314.592L240.67 325.218L334.076 1259.37L349.592 1252.59L257.6 314.592Z",
    fill: "#A3A3A3",
    stroke: "#D24343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M861.276 1330.71C865.275 1297.35 906.307 1195.22 906.307 1195.22L825.313 1200.35C818.831 1219.81 781.972 1326 780.179 1355.73C779.434 1365.13 780.985 1374.58 784.686 1383.19C788.388 1391.8 794.12 1399.3 801.349 1404.98L887.274 1385.92C887.274 1385.92 857.242 1364.2 861.276 1330.71Z",
    fill: "black",
    stroke: "#D24343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M257.6 314.592L349.592 1252.59L1394.58 1151.38L1302.59 441.103L257.6 314.592Z",
    fill: "black",
    stroke: "#D24343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M294 359L382.912 1211L1366 1123.14L1287.58 480.959L294 359Z",
    stroke: "#868686",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M334.076 1259.37L1389.72 1157.13L1394.58 1151.38L349.592 1252.59L334.076 1259.37Z",
    fill: "#373737",
    stroke: "#D24343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M659.671 1513.54C659.671 1513.54 681.876 1491.54 703.529 1481.23C725.183 1470.93 816.52 1435.07 920.753 1426.45C1024.99 1417.84 1271.55 1413.02 1288.07 1412.49C1304.58 1411.95 1323.69 1410.33 1325.72 1404.44C1327.76 1398.56 1328.72 1372.13 1328.72 1372.13L1255.66 1400.28L1248.35 1393.1C1248.35 1393.1 1167.87 1385.02 1020.33 1397.37C872.792 1409.72 783.006 1433.27 722.666 1453.23C662.326 1473.19 659.671 1513.54 659.671 1513.54Z",
    fill: "black",
    stroke: "#D24343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M549 1489L661.625 1505C661.625 1505 696.856 1451.76 867.982 1423.57C1039.11 1395.38 1255.52 1400.63 1255.52 1400.63L1329 1372.45C1329 1372.45 1048.12 1355.77 865.971 1380.79C683.818 1405.81 572.164 1459.77 549 1489Z",
    fill: "#707070",
    stroke: "#D24343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M549.99 1489C549.99 1489 541.956 1509.96 549.99 1513.08C558.024 1516.2 649.051 1517.24 656.085 1514.12C658.105 1513.26 659.941 1511.98 661.486 1510.37C663.031 1508.76 664.254 1506.85 665.084 1504.75L549.99 1489Z",
    fill: "black",
    stroke: "#D24343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.5 583L1313 724.5L1138.5 1141L1022 1151.5L1296.5 583Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.5 506.5L1290.5 541L983 1156L934.5 1160L1286.5 506.5Z",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_450_3993",
    x: 1365,
    y: 315,
    width: 669.5,
    height: 1077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_450_3993"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_450_3993",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_450_3993",
    x: 2104.5,
    y: 308,
    width: 263.5,
    height: 1069.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_450_3993"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_450_3993",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnTechnologies);
export default __webpack_public_path__ + "static/media/own-technologies.5db32e37306f01fd2c4d31aca71d2520.svg";
export { ForwardRef as ReactComponent };